import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import ThirdPartySearchModal, {
  ThirdPartySearchModalProps,
} from './ThirdPartySearchModal';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';

export type ThirdPartyForProposalType = {
  tpid?: number;
  tpreference?: string;
  tpname?: string;
};

export type ThirdPartyInputProps = {
  onChange?: any;
  onSelected?: (value: ThirdPartyForProposalType) => void;
  value?: ThirdPartyForProposalType;
  role?: string;
  parentid?: number;
  zindex?: number;
  isCreate?: boolean;
  onlytpid?: boolean;
  display?: boolean;
  style?: any;
  hideSearchButton?: boolean;
  disabled?: boolean;
  parcodeRole?: string;
  clear?: boolean;
  styleprops?: React.CSSProperties;
  EntityDataByid?: boolean;
  valueToDisplay?: ThirdPartyForProposalType;
  tptype?: string;
  tpid?: number
};

const ThirdPartyInput = ({
  onChange = noop,
  onSelected,
  value,
  role,
  parentid,
  isCreate,
  onlytpid,
  display,
  style,
  hideSearchButton,
  disabled,
  parcodeRole,
  clear,
  zindex,
  styleprops,
  EntityDataByid,
  valueToDisplay,
  tptype,
  tpid
}: ThirdPartyInputProps) => {
  const [Params, setParams] = useState<ThirdPartyForProposalType>({
    tpid: value?.tpid,
    tpreference: value?.tpreference,
    tpname: value?.tpname,
  });

  const { visible, close, open } = useModalState(false);
  const [tpModal, setTpModal] = useState(false);
  const [onClear, setOnClear] = useState(false);

  const handleSelect = (item: any) => {
    if (onSelected)
      onSelected({
        tpreference: item?.tpreference,
        tpname: item.tpname,
        tpid: item?.tpid,
      });

    setParams({
      tpreference: item?.tpreference,
      tpname: item.tpname,
      tpid: item?.tpid,
    });

    onlytpid ? onChange(item?.tpid) : onChange(item);

    close();
  };
  const handleClear = () => {

    // Clear the input and reset Params
    setParams({
      tpreference: undefined,
      tpname: undefined,
      tpid: undefined,
    });
    onChange(undefined); // Notify parent of cleared state
  };
  const hideThirdPartyModal = () => {
    setTpModal(false);
    close();
  };

  useEffect(() => {
    setOnClear(false);
    console.log("Clear------", value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (((typeof value === 'number') && value === 0) || ((typeof value === 'string') && value === "")) {
      setParams({
        tpreference: undefined,
        tpname: undefined,
        tpid: undefined,
      });
    }

  }, [clear, value]);


  return (
    <>
      <div style={style}>
        {display ? (
          <Typography.Link
            style={styleprops ? { fontSize: 'large' } : {}}
            onClick={() => {
              setTpModal(true);
            }}
            title="Open details"
            ellipsis
          >
            {/*onlytpid && !value?.tpid
              ? Params?.tpid
                ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
                : isCreate
                ? 'Create a Thirdparty....'
                : 'Select a ThirdParty'
              : value?.tpid
              ? `${value.tpreference ?? ''}  -  ${value.tpname ?? ''}`
              : isCreate
              ? 'Create a Thirdparty....'
              : Params?.tpid
              ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
          : 'Select a ThirdParty'*/
              valueToDisplay?.tpid ? `${valueToDisplay.tpreference ?? ''}  -  ${valueToDisplay.tpname ?? ''}` : value?.tpid
                ? `${value.tpreference ?? ''}  -  ${value.tpname ?? ''}` : ''
            }
          </Typography.Link>
        ) : (
          <AppSearchInput
            styleprops={styleprops}
            disabled={disabled}
            onSearch={() => {
              open();
              localStorage.removeItem('searchParams');
              localStorage.removeItem('searchParams_components');
            }}
            onClear={handleClear} // Update the onClear handler
            hidden={hideSearchButton}
            value={
              <Typography.Link
                style={styleprops ? { fontSize: 'large' } : {}}
                onClick={() => {
                  setTpModal(true);
                }}
                title="Open details"
                ellipsis
              >
                {onlytpid && !value?.tpid
                  ? Params?.tpid && !isNil(value)
                    ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
                    : isCreate
                      ? 'Create a Thirdparty....'
                      : 'Select a ThirdParty'
                  : value?.tpid && !isNil(value)
                    ? `${value.tpreference ?? ''}  -  ${value.tpname ?? ''}`
                    : isCreate
                      ? 'Create a Thirdparty....'
                      : Params?.tpid && !isNil(value)
                        ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
                        : 'Select a ThirdParty'}
              </Typography.Link>
            }
          />
        )}
      </div>
      <ThirdPartySearchModal
        tpid={tpid}
        initialSearchParams={{ role, parentid, tptype }}
        visible={visible}
        onCancel={() => {
          localStorage.removeItem('searchParams');
          close();
        }}
        onSelect={handleSelect}
        isProposalCreate={Boolean(isCreate)}
        setThirdPartyForProposal={setParams}
        hideThirdPartyModal={hideThirdPartyModal}
        parcodeRole={parcodeRole}

      />
      {value?.tpid || isCreate ? (
        <ThirdPartyModal
          onSelect={(item) => {
            handleSelect(item.generalData);
          }}
          iscreate={isCreate}
          title={
            onlytpid && !value?.tpid
              ? Params?.tpid && !isNil(value)
                ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
                : isCreate
                  ? 'Create a Thirdparty....'
                  : 'Select a ThirdParty'
              : value?.tpid && !isNil(value)
                ? `${value.tpreference ?? ''}  -  ${value.tpname ?? ''}`
                : isCreate
                  ? 'Create a Thirdparty....'
                  : Params?.tpid && !isNil(value)
                    ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
                    : 'Select a ThirdParty'
          }
          tpId={value?.tpid ?? 0}
          visible={tpModal}
          onCancel={() => setTpModal(false)}
          hideThirdPartyModal={hideThirdPartyModal}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ThirdPartyInput;
